var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['layout', _vm._isMobile() ? 'mobile' : ''],style:({
    'background-image': 'url(' + _vm.tenantConfig.json_homeBg.image + ')',
    'background-repeat': _vm.tenantConfig.json_homeBg.repeat,
    'background-color': _vm.tenantConfig.json_homeBg.color,
    'background-size': _vm.tenantConfig.json_homeBg.size,
  })},[(_vm.tenantConfig.headerType == 2)?_c('Header2',{attrs:{"id":"header"}}):(_vm.tenantConfig.headerType == 3)?_c('Header3',{attrs:{"id":"header"}}):_c('Header',{attrs:{"id":"header"}}),_c('div',{staticClass:"cms"},[_c('router-view')],1),_c('a-back-top'),_c('Footer',{attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }